export default __webpack_public_path__ + "static/media/team-3.c441962a.png";